import { llmPipelineTests } from './suites/llmPipelineTests';
import { utilityTests } from './suites/utilityTests';
import { componentTests } from './suites/componentTests';
import { featureTests } from './suites/featureTests';
import { apiHealthTests } from './suites/apiHealthTests';
import { dashboardTests } from './suites/dashboardTests';
import { projectFlowTests } from './suites/projectFlowTests';
import { meetingAnalysisTests } from './suites/meetingAnalysisTests';
import { pipelineTests } from './suites/pipelineTests';
import { emotionAnalysisTests } from './suites/emotionAnalysisTests';
import { questionnaireTests } from './suites/questionnaireTests';
import { analysisFlowTests } from './suites/analysisFlowTests';
import { articleTests } from './suites/articleTests';
import { textCoderTests } from './suites/textCoderTests';

export const TEST_REGISTRY = [
  {
    id: 'llm-pipeline',
    name: 'LLM Pipeline (fix-llm)',
    icon: '🤖',
    description: 'End-to-end validation of the AssemblyAI LLM Gateway migration — connectivity, plain-text output, EN/PT language, generateTask shape, sentiment format, legacy model name resolution, and full async chat flow through the queue',
    tests: llmPipelineTests,
  },
  {
    id: 'utilities',
    name: 'Utility Functions',
    icon: '⚙️',
    description: 'Pure function calculations, formatters, and mappers',
    tests: utilityTests,
  },
  {
    id: 'components',
    name: 'UI Components',
    icon: '🧩',
    description: 'Component rendering and basic interaction tests',
    tests: componentTests,
  },
  {
    id: 'features',
    name: 'Feature Integration',
    icon: '🔗',
    description: 'Feature pages and components with mocked API responses',
    tests: featureTests,
  },
  {
    id: 'api-health',
    name: 'API Health',
    icon: '🔌',
    description: 'Backend connectivity and response code checks',
    tests: apiHealthTests,
  },
  {
    id: 'dashboard',
    name: 'Global Dashboard',
    icon: '📊',
    description: 'Statistics, calendar, conversations, tasks and all-projects widgets across all user projects',
    tests: dashboardTests,
  },
  {
    id: 'project-flow',
    name: 'Project Flow',
    icon: '🔬',
    description: 'Every step and substep of the project flow: Prepare, Question, Analyze, Report — including create-modal interactions and the full upload type → modal chain',
    tests: projectFlowTests,
  },
  {
    id: 'meetings-analysis',
    name: 'Meetings & Analysis',
    icon: '🎙️',
    description: 'Meeting list, analysis cards, and file upload type selector',
    tests: meetingAnalysisTests,
  },
  {
    id: 'research-pipeline',
    name: 'Research Pipeline',
    icon: '🔁',
    description: 'Pipeline list page, pipeline cards by status, and empty state',
    tests: pipelineTests,
  },
  {
    id: 'emotion-analysis',
    name: 'Emotion & Sentiment Analysis',
    icon: '🧠',
    description: 'Audio/video emotion cards, overall sentiment and participation cards',
    tests: emotionAnalysisTests,
  },
  {
    id: 'questionnaires',
    name: 'Questionnaires',
    icon: '📋',
    description: 'Questionnaire list, analytics cards, and response/reply views',
    tests: questionnaireTests,
  },
  {
    id: 'analysis-flow',
    name: 'Analysis Upload Flow',
    icon: '📤',
    description: 'Upload type selector, all 4 upload modals (audio/video/PDF/transcription), and emotion card status variants',
    tests: analysisFlowTests,
  },
  {
    id: 'articles',
    name: 'Articles',
    icon: '📝',
    description: 'Article card, create/edit modal form fields, and ArticlesTab empty and populated states',
    tests: articleTests,
  },
  {
    id: 'text-coder',
    name: 'Text Coder',
    icon: '🏷️',
    description: 'TextCodeModal (create/edit), TextCodeCombinationModal, CodeCard, Codebook (empty/with codes/click-throughs), TextCodes panel, and TextCoder page no-file state',
    tests: textCoderTests,
  },
];

export const ALL_TESTS = TEST_REGISTRY.flatMap(suite =>
  suite.tests.map(test => ({ ...test, suiteId: suite.id, suiteName: suite.name }))
);
